import React from 'react'
import {
    SectionList,
    RefreshControl,
    Dimensions
} from 'react-native'
import { Button, VStack, Box, Image, Text } from 'native-base'
import moment from 'moment'
import { useHeaderHeight } from '@react-navigation/stack';

export default function MemberDetail(props) {
    const headerHeight = useHeaderHeight();
    const { t, member, pospalModalVisible, pospals } = props
    const { avatar, username, email, createdAt, credit } = member
    const routes = [
        { title: t('MemberOrderList'), route: 'MemberOrderList' },
        { title: t('EditCredit'), route: 'EditCredit' },
        { title: t('MemberCreditList'), route: 'MemberCreditList' }
    ]



    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} p={2}>
            <VStack alignItems="center">
                <Image size={'md'} resizeMode={'cover'} bg={'gray.400'} borderRadius={40} source={{ uri: avatar }} fallbackSource={{ uri: "https://shopper-api.shopper.com.hk/Storage/user/avatar/default.jpg", }} />
                <Text isTruncated px={2} py={1} color={'black'}>{`${username}`}</Text>
                <Text isTruncated px={2} py={1} color={'black'} fontSize={'xs'}>{`${email}`}</Text>
                <Text isTruncated px={2} py={1} color={'black'} fontSize={'xs'}>{t('joinDate', { createdAt: moment(createdAt).format('YYYY年MM月DD日') })}</Text>
                <Text isTruncated px={2} py={1} color={'primary.100'} fontSize={'xs'}>{`${credit} 積分`}</Text>
                <Box>
                    {routes.map((f, index) => {
                        return (
                            <Button m={1} key={index.toString()} onPress={() => props.onActionPress(f.route)}>
                                <Text isTruncated px={2} py={1} color={'white'}>{f.title}</Text>
                            </Button>
                        )
                    })}
                    {/* <Button m={1} onPress={() => props.onPospalUserPress()}>
                        <Text isTruncated px={2} py={1} color={'white'}>{t('PospalUser')}</Text>
                    </Button> */}
                </Box>
            </VStack>
        </Box>
    )
}